var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product)?_c('product-details',{attrs:{"product":_vm.product}}):_c('div',{staticClass:"product-loading"},[_c('div',{staticClass:"page-spinner-wrapper"},[_c('span',{staticClass:"spinner-circle"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }